import { createContext, useState } from 'react';

import { usePersistedState } from '../hooks';

const OnboardingContext = createContext();

const OnboardingProvider = ({ children }) => {
  const [isManualAddress, setIsManualAddress] = usePersistedState('isManualAddress', false);
  const [addressId, setAddressId] = usePersistedState('addressId', false);
  const [termsAndConditions, setTermsAndConditions] = usePersistedState('termsAndConditions', null);
  const [redirectUrl, setRedirectUrl] = usePersistedState('redirectUrl', '');
  const [hasOnboarded, setHasOnboarded] = usePersistedState('hasOnboarded', false);
  const initialUserState = {
    attributes: {
      given_name: '',
      family_name: '',
      email: '',
    },
  };
  const [currentUser, setUser] = usePersistedState('currentUser', initialUserState);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = usePersistedState('deleteError', null);
  const [progressPercentage, setProgressPercentage] = usePersistedState(0);
  const [postcode, setPostcode] = usePersistedState('postcode', null);
  const [importTariffId, setImportTariffId] = usePersistedState('importTariffId', null);
  const [exportTariffId, setExportTariffId] = usePersistedState('exportTariffId', null);
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(null);
  const [isSaving, setIsSaving] = usePersistedState('isSaving', false);
  const [pvSystemSize, setPvSystemSize] = usePersistedState('pvSystemSize', null);
  const [solarPanelArrayCount, setSolarPanelArrayCount] = usePersistedState('solarPanelArrayCount', null);
  const [hasSmartTariff, setHasSmartTariff] = usePersistedState('hasSmartTariff', 'no');
  const [solarPanelArrayData, setSolarPanelArrayData] = usePersistedState('solarPanelArrayData', null);
  const [numPanels, setNumPanels] = usePersistedState('numPanels', null);
  const [hasSolarDiverter, setHasSolarDiverter] = usePersistedState('hasSolarDiverter', 'no');
  const [importSupplier, setImportSupplier] = usePersistedState('importSupplier', null);
  const [exportSupplier, setExportSupplier] = usePersistedState('exportSupplier', null);
  const [hasEv, setHasEv] = usePersistedState('hasEv', null);
  const [batteries, setBatteries] = usePersistedState('batteries', [
    { manufacturer: null, model: null, quantity: null },
  ]);
  const [manufacturerDetails, setManufacturerDetails] = usePersistedState('manufacturerDetails', null);
  const [batteryCapacity, setBatteryCapacity] = usePersistedState('batteryCapacity', null);
  const [inverterManufacturer, setInverterManufacturer] = usePersistedState('inverterManufacturer', null);
  const [inverter, setInverter] = usePersistedState('inverter', null);
  const [hasExportLimit, setHasExportLimit] = usePersistedState('hasExportLimit', null);

  const [inverterUnitList, setInverterUnitList] = useState([]);
  const [batteryUnitList, setBatteryUnitList] = useState([]);

  const [hardwareDetails, setHardwareDetails] = usePersistedState('hardwareDetails', null);
  const [exportTariffs, setExportTariffs] = useState(null);

  return (
    <OnboardingContext.Provider
      value={{
        isManualAddress,
        addressId,
        setAddressId,
        setIsManualAddress,
        redirectUrl,
        setRedirectUrl,
        termsAndConditions,
        setTermsAndConditions,
        hasOnboarded,
        setHasOnboarded,
        currentUser,
        setUser,
        showDeleteAccountModal,
        setShowDeleteAccountModal,
        isDeleting,
        setIsDeleting,
        deleteError,
        setDeleteError,
        showAlert,
        setShowAlert,
        alert,
        setAlert,
        isSaving,
        setIsSaving,
        importTariffId,
        setImportTariffId,
        exportTariffId,
        setExportTariffId,
        progressPercentage,
        setProgressPercentage,
        postcode,
        setPostcode,
        pvSystemSize,
        setPvSystemSize,
        solarPanelArrayCount,
        setSolarPanelArrayCount,
        solarPanelArrayData,
        setSolarPanelArrayData,
        numPanels,
        setNumPanels,
        hasSolarDiverter,
        setHasSolarDiverter,
        hasSmartTariff,
        setHasSmartTariff,
        importSupplier,
        setImportSupplier,
        exportSupplier,
        setExportSupplier,
        hasEv,
        setHasEv,
        batteries,
        setBatteries,
        batteryCapacity,
        setBatteryCapacity,
        inverterManufacturer,
        setInverterManufacturer,
        manufacturerDetails,
        setManufacturerDetails,
        inverter,
        setInverter,
        hasExportLimit,
        setHasExportLimit,
        inverterUnitList,
        setInverterUnitList,
        batteryUnitList,
        setBatteryUnitList,
        hardwareDetails,
        setHardwareDetails,
        exportTariffs,
        setExportTariffs,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export { OnboardingContext, OnboardingProvider };
